var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1.875C10.3452 1.875 10.625 2.15482 10.625 2.5L10.625 10.9911L13.7247 7.89138C13.9688 7.6473 14.3645 7.6473 14.6086 7.89138C14.8527 8.13546 14.8527 8.53118 14.6086 8.77526L10.4419 12.9419C10.1979 13.186 9.80212 13.186 9.55805 12.9419L5.39138 8.77526C5.1473 8.53118 5.1473 8.13546 5.39138 7.89138C5.63546 7.6473 6.03118 7.6473 6.27526 7.89138L9.37499 10.9911L9.375 2.5C9.375 2.15482 9.65482 1.875 10 1.875ZM2.5 11.875C2.84518 11.875 3.125 12.1548 3.125 12.5V15.8333C3.125 16.1096 3.23475 16.3746 3.4301 16.5699C3.62545 16.7653 3.8904 16.875 4.16667 16.875H15.8333C16.1096 16.875 16.3746 16.7653 16.5699 16.5699C16.7653 16.3746 16.875 16.1096 16.875 15.8333V12.5C16.875 12.1548 17.1548 11.875 17.5 11.875C17.8452 11.875 18.125 12.1548 18.125 12.5V15.8333C18.125 16.4411 17.8836 17.024 17.4538 17.4538C17.024 17.8836 16.4411 18.125 15.8333 18.125H4.16667C3.55888 18.125 2.97598 17.8836 2.54621 17.4538C2.11644 17.024 1.875 16.4411 1.875 15.8333V12.5C1.875 12.1548 2.15482 11.875 2.5 11.875Z",
  fill: "#00538F"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e8525830.svg";
export { ForwardRef as ReactComponent };